module.exports = __webpack_public_path__ + "static/media/nft-38.2f6372f5.jpg";